import React from 'react'
import businessInfo from '../businessInfo'
import { Link } from 'react-router-dom'
import { 
  PhoneIcon, 
  EnvelopeIcon, 
  MapPinIcon,
  BuildingOfficeIcon 
} from '@heroicons/react/24/outline'

function Footer() {
  return (
    <footer className="bg-gradient-to-t from-blue-900 to-blue-800 text-white relative overflow-hidden">
      {/* Background Decor */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-yellow-500/10 via-transparent to-transparent" />
      
      <div className="relative mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          
          {/* Logo & Slogan */}
          <div className="lg:col-span-1">
            <div className="mb-2 flex flex-col items-start">
              <img src="/logo.png" alt="Logo" className="h-12 w-auto rounded-xl shadow-lg mb-2" />
              <p className="text-yellow-300 font-semibold text-sm">Ihr Payroll-Partner</p>
            </div>
            <h3 className="font-black text-2xl text-white mb-2">{businessInfo.companyName}</h3>
            <p className="text-gray-300 leading-relaxed mb-6">
              Zuverlässige Lohnabrechnungen für Kanzleien. DATEV-kompatibel. GoBD-sicher.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white hover:underline transition">Home</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-white hover:underline transition">Dienstleistungen</Link>
              </li>
              <li>
                <Link to="/prices" className="text-gray-300 hover:text-white hover:underline transition">Preise</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white hover:underline transition">Kontakt</Link>
              </li>
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Kontakt</h4>
            <div className="space-y-4">
              <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-3 p-3 rounded-xl bg-white/5 hover:bg-white/10 transition">
                <PhoneIcon className="w-5 h-5 text-yellow-400" />
                <span>{businessInfo.phone}</span>
              </a>
              <a href={`mailto:${businessInfo.email}`} className="flex items-center gap-3 p-3 rounded-xl bg-white/5 hover:bg-white/10 transition">
                <EnvelopeIcon className="w-5 h-5 text-yellow-400" />
                <span>{businessInfo.email}</span>
              </a>
              <div className="flex items-center gap-3 p-3 rounded-xl bg-white/5">
                <MapPinIcon className="w-5 h-5 text-yellow-400" />
                <span>{businessInfo.address.city}</span>
              </div>
            </div>
          </div>

          {/* Rechtliches & Social */}
          <div className="lg:col-span-1 lg:row-span-2">
            <h4 className="text-lg font-bold mb-6 text-white">Rechtliches</h4>
            <ul className="space-y-2 mb-8">
              <li><Link to="/impressum" className="text-sm text-gray-300 hover:text-white hover:underline block">Impressum</Link></li>
              <li><Link to="/datenschutz" className="text-sm text-gray-300 hover:text-white hover:underline block">Datenschutz</Link></li>
              <li><Link to="/agb" className="text-sm text-gray-300 hover:text-white hover:underline block">AGB</Link></li>
              <li><Link to="/goBD" className="text-sm text-gray-300 hover:text-white hover:underline block">GoBD-Einhaltung</Link></li>
            </ul>
            
            {/* Social / Trust */}
            <div className="space-y-4">
              <div className="flex items-center gap-4 text-sm text-gray-400">
                <span>✅</span>
                <span>GoBD-konform</span>
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-400">
                <span>✅</span>
                <span>DSGVO-zertifiziert</span>
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-400">
                <span>✅</span>
                <span>Elster-zertifiziert</span>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="text-sm text-gray-400">
            © 2026 {businessInfo.companyName}. Alle Rechte vorbehalten.
          </span>
          
          <div className="flex items-center gap-6 text-sm text-gray-400">
            <Link to="/impressum" className="hover:text-white hover:underline transition">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white hover:underline transition">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
